import type { Client } from '@/core/domain';
import type { ClientRepository } from '../repositories/client-repository';

export class CreateClientUseCase {
  constructor(private readonly repository: ClientRepository) {}

  async execute(userId: string, client: Client): Promise<Client> {
    return this.repository.create(userId, client);
  }
}
